import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ModalComponent} from "@app/shared/components";
import {UntypedFormControl, UntypedFormGroup} from "@angular/forms";
import {TranslateService} from "@ngx-translate/core";
import {Batch} from "@models/batch.model";

@Component({
    selector: 'app-edit-batch',
    templateUrl: './edit-batch.component.html',
    styleUrls: ['./edit-batch.component.scss']
})
export class EditBatchComponent {

    @ViewChild(ModalComponent, {static: true}) modal: ModalComponent;

    @Input() dismissible = true;
    @Input() isLoading = false;

    @Output() cancelInfoModal = new EventEmitter<any>();
    @Output() editBatch = new EventEmitter<any>();

    batchForm: UntypedFormGroup;
    showValidations = false;
    selectedBatch;

    constructor(public translateService: TranslateService) {
        this.batchForm = new UntypedFormGroup({
            'name': new UntypedFormControl('')
        });
    }

    open(batch: Batch = null) {
        this.modal.open();
        this.selectedBatch = batch;
        this.batchForm.get('name').setValue(batch ? batch.name : null);
    }

    close() {
        this.batchForm.reset();
        this.modal.close();
    }

    onCancel() {
        this.cancelInfoModal.emit();
    }

    onBatchSave() {
        if (!this.batchForm.valid) {
            this.showValidations = true;
            return;
        }
        this.showValidations = false;
        const formData = Object.assign({}, this.batchForm.value);
        formData.id = this.selectedBatch ? this.selectedBatch.id : null;

        this.editBatch.emit({
            data: formData
        });
    }
}
